import { useCallback, useMemo } from "react";

export function usePhasePagination({
	selectedTab,
	activePage,
	activeLimit,
	activeTotal,
	archivedPage,
	archivedLimit,
	archivedTotal,
	setActivePage,
	setActiveLimit,
	setArchivedPage,
	setArchivedLimit,
}) {
	const page = useMemo(
		() => (selectedTab === 0 ? activePage : archivedPage),
		[selectedTab, activePage, archivedPage]
	);
	const limit = useMemo(
		() => (selectedTab === 0 ? activeLimit : archivedLimit),
		[selectedTab, activeLimit, archivedLimit]
	);
	const total = useMemo(
		() => (selectedTab === 0 ? activeTotal : archivedTotal),
		[selectedTab, activeTotal, archivedTotal]
	);

	const handleChangePage = useCallback(
		(_, newPage) => {
			if (selectedTab === 0) {
				setActivePage(newPage);
			} else {
				setArchivedPage(newPage);
			}
		},
		[selectedTab, setActivePage, setArchivedPage]
	);

	const handleChangeLimitPerPage = useCallback(
		(event) => {
			const newLimit = parseInt(event.target.value, 10);
			if (selectedTab === 0) {
				setActiveLimit(newLimit);
				setActivePage(0);
			} else {
				setArchivedLimit(newLimit);
				setArchivedPage(0);
			}
		},
		[selectedTab, setActiveLimit, setActivePage, setArchivedLimit, setArchivedPage]
	);

	return {
		page,
		limit,
		total,
		handleChangePage,
		handleChangeLimitPerPage,
	};
}
